
import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { useLessonCompletions } from './useLessonCompletions';
import { Award } from 'lucide-react';

export const useMilestoneAchievements = (courseId: string) => {
  const { calculateProgress } = useLessonCompletions(courseId);
  const [lastProgress, setLastProgress] = useState(0);

  useEffect(() => {
    const progress = calculateProgress();
    
    // Get shown milestones from localStorage
    const storageKey = `course-${courseId}-milestones`;
    const savedMilestones = localStorage.getItem(storageKey);
    const shownMilestones = savedMilestones ? new Set(JSON.parse(savedMilestones)) : new Set();

    // Check milestone achievements
    const milestones = [25, 50, 100];
    milestones.forEach(milestone => {
      if (progress >= milestone && !shownMilestones.has(milestone)) {
        // Show toast only for milestones not yet shown
        toast.success(
          <div className="flex items-center gap-2">
            <Award className="h-6 w-6 text-yellow-500" />
            <span>Course Milestone: {milestone}% Complete!</span>
          </div>, 
          {
            description: "Keep up the great work!",
            duration: 5000
          }
        );
        
        // Add milestone to shown milestones and save to localStorage
        shownMilestones.add(milestone);
        localStorage.setItem(storageKey, JSON.stringify([...shownMilestones]));
      }
    });

    setLastProgress(progress);
  }, [calculateProgress, courseId, lastProgress]);
};
